/* eslint-disable react/react-in-jsx-scope */
import { useTranslation } from "react-i18next";
import LoginBtn from "src/components/auth/loginButton/LoginBtn";
import logo from "../assets/images/logo_dark.png";

export default function LandingPage(): JSX.Element {
  const { t } = useTranslation();

  return (
    <>
      <section
        className="px-2 pt-20 md:px-0 min-h-[60vh] flex flex-col justify-center"
        style={{ background: "var(--background-color)" }}
      >
        <div className="container items-center max-w-6xl px-5 mx-auto space-y-6 text-center">
          <span className="flex items-center justify-center">
            <img src={logo} alt={t("logo.alt-text")} className="w-100 h-10" />
          </span>
          <h1
            className="text-4xl font-extrabold tracking-tight text-left md:text-6xl md:text-center flex-wrap"
            style={{ fontFamily: "'Syne', system-ui, sans-serif", color: "var(--font-color)" }}
          >
            <span className="block">{t("brandName")}</span>
          </h1>
          <span>
            <br />
            <LoginBtn />
          </span>
          <div
            className="relative flex flex-col justify-center md:flex-row md:space-x-4"
            style={{ color: "var(--font-color)" }}
          >
            <span className="block">{t("siteDescription")}</span>
          </div>
        </div>
      </section>
    </>
  );
}
